import { api, getBlob } from "../../services/NetworkBase";
import { saveAs } from "file-saver";

export async function GetQuotes(startDate,endDate,orderStatus,clientType,searchText, page,pageSize, accountNumbers = "") {
	try {
		let response = await api
		.get(`vlp/quotes?startDate=${startDate}&endDate=${endDate}&searchText=${searchText}&clientType=${clientType}&page=${page}&orderStatus=${orderStatus}&pageSize=${pageSize}&accountNumbers=${encodeURIComponent(accountNumbers)}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}



export async function GetQuoteById(quoteNumber) {	
	try {
		let response = await api
		.get(`vlp/quotes/${quoteNumber}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}


export async function GetQuoteComments() {	
	try {
		let response = await api
		.get(`vlp/quotes/system-comments`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}


export async function UpdateQuote(quote) {	
	try {
        let response = await api.put("vlp/quotes", { json: quote });
		return response;
	} catch (error) {
		throw error;
	}
}

export async function SaveQuote(quote) {	
	try {
		let response = await api.post("vlp/quotes", { json: quote }).json();
		return response;
	} catch (error) {
		throw error;
	}
}



/**
 * Duplicates a quote. The copies share the source quote's details and line
 * items; each one gets its own new quote number.
 * @param {string} id - Quote number to copy
 * @param {number} copies - How many copies to create
 * @returns {Promise<Object>} - { results: string[] } the new quote numbers
 */
export async function DuplicateQuoteById(id, copies = 1) {
	try {
		const encodedId = encodeURIComponent(id);
		let response = await api
		.post(`vlp/quotes/duplicate/${encodedId}`, { json: { copies } })
			.json();
		// The API returns the new quote numbers as an array. An older API build
		// returns a single quote number as a bare string, so normalize here and
		// callers can always treat results as a list.
		const results = response?.results;
		return {
			...response,
			results: Array.isArray(results) ? results : results ? [results] : [],
		};
	} catch (error) {
		throw error;
	}
}


export async function GetQuoteTransactionById(quoteNumber,recordId) {	
	try {
		let response = await api
		.get(`vlp/quotes/${quoteNumber}/transaction/${recordId}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function UpdateQuoteTransaction(quote) {	
	try {
        let response = await api.put("vlp/quotes/transaction", { json: quote });
		return response;
	} catch (error) {
		throw error;
	}
}

export async function SaveQuoteTransaction(quote) {	
	try {
		let response = await api.post("vlp/quotes/transaction", { json: quote }).json();
		return response;
	} catch (error) {
		throw error;
	}
}
export async function DeleteQuoteTransaction(quoteNumber ,recordId) {   
    try {        
        let response = await api
        .delete(`vlp/quotes/${quoteNumber}/transaction/${recordId}`)
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}


/**
 * Saves the display order of the transactions on a quote.
 * @param {string} quoteNumber - Quote number
 * @param {number[]} recordIds - quotrans record ids in the desired order
 * @returns {Promise<Object>} - { results: true }
 */
export async function ReorderQuoteTransactions(quoteNumber, recordIds) {
    try {
        const encodedQuoteNumber = encodeURIComponent(quoteNumber.toString().trim());
        let response = await api
            .put(`vlp/quotes/${encodedQuoteNumber}/transactions/reorder`, {
                json: { recordIds },
            })
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}


export async function DeleteQuote(quoteNumber) {   
    try {        
        let response = await api
        .delete(`vlp/quotes/${quoteNumber}`)
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}

export async function SendBulkQuoteEmails(quoteNumbers) {   
    try {        
        let response = await api
            .post(`vlp/quotes/email`, { json: quoteNumbers })
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}

export async function PrintQuote(quoteNumber) {
    let blob = await getBlob(`vlp/quotes/${quoteNumber}/report`);
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
    saveAs(blob, `${quoteNumber}.pdf`);
}
